





























import { BaseButtonIcon, BaseIcon } from '@getaccept/lib-ui';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    BaseButtonIcon,
    BaseIcon,
  },
  props: {
    showProgressBar: {
      type: Boolean,
      default: true,
    },
    closable: {
      type: Boolean,
    },
  },
});
